import { connect } from 'react-redux';
import View from './AlightView';
import {
  currentClientIdSelector,
  selectFeatureFlags,
  selectIsUserClient,
  selectPortalName,
} from '../CommonSelectors/CommonAreaSelector';
import { isFeatureEnabled } from '../_hooks/useFeatureFlag';
import { Feature } from '../CommonSelectors/CommonArea.types';

const { ADV } = window;
const mapStateToProps = state => ({
  name: (ADV.data.user.AlightLandingPage || {}).ExternalFirstName,
  agreementText: (ADV.data.user.AlightLandingPage || {}).ClientServiceAgreementText,
  csrf: ADV.settings.tokens.xsrf,
  portalName: selectPortalName(state),
  clientId: currentClientIdSelector(state),
  showLanguagePreference:
    isFeatureEnabled(Feature.LocalizeAccess, selectFeatureFlags(state)) &&
    selectIsUserClient(state),
});

export default connect(mapStateToProps)(View);
